import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { services } from '../data/mockData';

export const Services = () => {
  const navigate = useNavigate();

  const handleServiceClick = () => {
    navigate('/pricelist');
  };

  return (
    <section id="services" className="section-padding bg-white">
      <div className="container mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <h2 className="section-title mb-4">
            Unsere Services
          </h2>
          <p className="section-subtitle">
            Von klassischen Schnitten bis zu modernen Colorationen – wir bringen deine Haare zum Strahlen
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => (
            <div 
              key={service.id} 
              className="service-card group cursor-pointer"
              onClick={handleServiceClick}
            >
              {/* Image */}
              <div className="service-image-container">
                <img 
                  src={service.image}
                  alt={service.title}
                  className="service-image"
                />
                <div className="service-overlay">
                  <ArrowRight className="w-6 h-6 text-white transform translate-x-0 group-hover:translate-x-2 transition-transform" />
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <h3 className="text-xl font-bold mb-2 group-hover:text-accent transition-colors">
                  {service.title}
                </h3>
                <p className="text-gray-600">
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
